import { getCurrentLanguage } from "Core/Languages";

export class HeartBeat {
  private intervalId: ReturnType<typeof setInterval> | null = null;

  private lang: string = getCurrentLanguage;
  private readonly url = window.location.origin + '/' + this.lang + '/ping/';
  private readonly intervalMs = 300000;

  public init(): void {
    if (this.intervalId !== null) return;
    this.sendPing();
    this.intervalId = setInterval(() => this.sendPing(), this.intervalMs);
  }

  private sendPing(): void {
    fetch(this.url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ ping: true })
    })
      .then(response => response.json())
      .then(pong => {})
      .catch(() => {});
  }
}import { getCurrentLanguage } from "Core/Languages";

export class HeartBeat {
  private intervalId: ReturnType<typeof setInterval> | null = null;

  private lang: string = getCurrentLanguage;
  private readonly url = window.location.origin + '/' + this.lang + '/ping/';
  private readonly intervalMs = 300000;

  public init(): void {
    if (this.intervalId !== null) return;
    this.sendPing();
    this.intervalId = setInterval(() => this.sendPing(), this.intervalMs);
  }

  private sendPing(): void {
    fetch(this.url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ ping: true })
    })
      .then(response => response.json())
      .then(pong => {})
      .catch(() => {});
  }
}